import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { getBadgeById, getRarityColor } from '../utils/badgeDefinitions';
import './Badge.css';

const Badge = ({ badge, onClick, size = 'medium', showTooltip = true }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  // If badge is just an ID, get the full badge definition
  const badgeData = typeof badge === 'string' ? getBadgeById(badge) : badge;
  
  if (!badgeData) return null;
  
  const { id, name, description, icon, color, bgColor, rarity } = badgeData;
  const rarityColor = getRarityColor(rarity);
  
  const sizeClasses = {
    small: 'badge-small',
    medium: 'badge-medium',
    large: 'badge-large'
  };
  
  const badgeClass = `badge ${sizeClasses[size] || sizeClasses.medium} badge-${rarity}`;
  
  return (
    <div className="badge-wrapper">
      <motion.div
        className={badgeClass}
        style={{
          '--badge-color': color,
          '--badge-bg': bgColor,
          '--rarity-color': rarityColor
        }}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: 'spring', stiffness: 400, damping: 17 }}
      >
        <div className="badge-icon">{icon}</div>
        <div className="badge-content">
          <div className="badge-name">{name}</div>
          {size === 'large' && (
            <div className="badge-description">{description}</div>
          )}
        </div>
        <div className="badge-rarity-indicator" style={{ backgroundColor: rarityColor }} />
      </motion.div>
      
      {showTooltip && isHovered && (
        <motion.div
          className="badge-tooltip"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
        >
          <div className="tooltip-name">{name}</div>
          <div className="tooltip-description">{description}</div>
          <div className="tooltip-rarity">Rarity: <span style={{ color: rarityColor }}>{rarity}</span></div>
        </motion.div>
      )}
    </div>
  );
};

export default Badge;


